export default __webpack_public_path__ + "static/media/cjpy_logo.1bab7d81.png";